// extracted by mini-css-extract-plugin
export default {"row":"xEKQAlUAaorta_5MYCw_","changeCell":"oVfGWsQSafioJelst74a"};